import { Component, OnInit, ViewChild, Directive, Input } from '@angular/core';

import { ClienteLogin, ClienteXCiudad, ConsultaCliente } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity, BusquedaSiniestralidad, TitularVam } from "../entities/polizas_cliente_entity";
import { AplicacionesTransporteComponent } from "../aplicacionesTransporte/aplicaciones-transporte.component";
import { ExclusionVehiculos } from "../solicitudes/solicitud-vehiculos.component";
import { ExclusionVehiculosService } from "../solicitudes/solicitud-vehiculos.service";
import { ExclusionEquipos } from "../solicitudes/solicitud-equipo.component";
import { ExclusionEquiposService } from "../solicitudes/solicitud-equipo.service";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { PolizasVencidasNoLiberadasEntity } from "../fianzas/entities/polizas-vencidasnoLiberadas_entity";
import { ComboBox } from "../../../components/common/utils/combobox";
import { ClienteVAM, UsuarioVamTit } from '../../login/cliente_login';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { PolizaVAM, SiniestralidadClientes, ResumenSiniestralidad, SiniestralidadMaternidad, RankingDiagnosticos, ProveedoresSiniestralidad, BusquedaFacturacion } from '../entities/vam_entities';
import { detalleCreditoService } from './detalleCredito.service';
import { SeguroCreditoEntity, AceptacionCarteraEntity, SiniestralidadEntity, UsuCupoEntity, CriteriosBusqueda } from '../entities/sistema_credito_entity';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'detalleCredito',
    providers: [],
    templateUrl: 'detalleCredito.template.html'

})

export class detalleCredito extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    polizas: PolizaEntity[];
    public showLoader: string;
    opcion: number;
    polizaContratada: PolizaEntity;

    showSiniestralidad: boolean;

    polizaDetalle: PolizasVencidasNoLiberadasEntity;
    detallePolizas1: PolizasVencidasNoLiberadasEntity[];
    @ViewChild('detallePolizas')
    modal: ModalComponent;
    poliza: string;
    rutaMovimientos: boolean;
    opcionSeleccionada: number = 0;
    rowSelect: number;
    showSolicitudes: boolean;
    opcionCliente: number;
    comboClientes: ComboBox[];
    busqueda: BusquedaSiniestralidad;
    opcionBusqueda: number;
    codigoGrupo: number;
    codigoCliente: number;
    codigounidad: number;
    usuarioVam: UsuarioVamTit;
    titular: TitularVam;
    usuarioempresaretrive: ClienteXCiudad;
    public resumen;
    showTab: boolean;
    public lstAcepatcionCartera;
    public lstUsoCupos:UsuCupoEntity[];
    public lstSiniestralidad;
    public resumenCredito: SeguroCreditoEntity;
    public top;

    detalles: PolizaEntity;
    CodigoCiudad: number;
    comboTipoNegocio: ComboBox[];
    comboRamos: ComboBox[];
    comboAseguradora: ComboBox[];
    comboPlanes: ComboBox[];
    consultaCliente = new ConsultaCliente();
    public lineChartData: Array<any>;
    public lineChartLabels: Array<any>;
    public reembolsoChartData: Array<any>;
    public numReclamosChartData: Array<any>;
    public barChartData: any[];
    public criteriosBusqueda:CriteriosBusqueda= new CriteriosBusqueda();

    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    id: 'yAxis1',
                    position: 'left'
                },
                {
                    id: 'yAxis2',
                    position: 'right'
                }
            ]
        }
    };
    public genChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false
    };
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public barChartType: string = 'bar';
    public barChartLabels: string[];

    public pieChartLabels: string[];
    public pieChartData: number[];
    public pieChartType: string = 'pie';

    public lineChartColors: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
    ];
    constructor(
        private detalleCredito: detalleCreditoService,
        private exclusionVehiculosService: ExclusionVehiculosService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public polizasLiberadasService: PolizasVencidasNoLiberadasService,
        private consultarVAM: ConsultarUsuarioVAM) {
        super();
        this.resumen = new SeguroCreditoEntity();
        this.lstAcepatcionCartera = new AceptacionCarteraEntity();
        this.lstSiniestralidad = new SiniestralidadEntity();
        this.showTab = false;

        this.detalles = new PolizaEntity();
        this.consultaCliente = new ConsultaCliente();
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 10);
        this.yearRange = (now.getFullYear() - 10) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
    }

    ngOnInit() {
        this.opcionCliente = 1;
        this.codigoGrupo = 0;
        this.opcionBusqueda = 1;
        //Inicializando busqueda

        try {
            this.usuarioempresaretrive = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioempresaretrive = this.sesionStorageService.retrieve("usuarioempresa");
        }
        let cliente = this.usuarioempresaretrive.CodigoCliente;
        this.CodigoCiudad = this.usuarioempresaretrive.Ciudad;
        console.log(this.usuarioempresaretrive);
        this.busqueda = new BusquedaSiniestralidad();
        this.busqueda.CodigoPlan = 0;
        this.busqueda.CodigoRamo = "0";
        this.busqueda.CodigoCiudad = this.CodigoCiudad;
        this.busqueda.CodigoUnidad = Number(sessionStorage.getItem("unidad"));
        this.busqueda.TopRegistros = 10;
        this.busqueda.TipoFecha = 1;
        this.busqueda.CodigoTipoNegocio = 0;
        this.busqueda.CodigoAseguradora = 0;
        this.showSiniestralidad = false;

        if ((cliente != null && Number(cliente) > 0)) {
            this.showLoader = "sk-loading";

            if (cliente != null) {
                this.codigoCliente = Number(cliente);
                this.busqueda.CodigoCliente = this.codigoCliente;
            }


            this.consultaCliente.Cliente = this.codigoCliente;
            this.consultaCliente.Grupo = this.codigoGrupo;
            this.consultaCliente.Ciudad = this.CodigoCiudad;
            this.consultaCliente.Unidad = Number(sessionStorage.getItem("unidad"));
            this.showLoader = "";
            /*this.detalleCredito.getClientes(consultaCliente).subscribe(infoPantalla => {
                this.comboClientes = infoPantalla;
                this.showLoader = "";
              

               console.log(infoPantalla);
                
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });*/
        }
        else {
            swal({
                title: 'Alerta',
                text: 'Seleccione un cliente o grupo para consultar su siniestralidad.',
                type: 'warning',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        }
        this.consultarDetalle();
        this.lineChartData = new Array<any>();
        this.lineChartLabels = new Array<any>();
        this.reembolsoChartData = new Array<any>();
        this.numReclamosChartData = new Array<any>();
        this.barChartData = [];
        this.pieChartLabels = [];
        this.pieChartData = [];
        if (this.lstAcepatcionCartera != undefined && this.lstAcepatcionCartera != null) {
            this.barChartData = [{ data: [this.lstAcepatcionCartera.MontoSolicitado], label: 'VALOR' },
            { data: [this.lstAcepatcionCartera.MontoOtorgado], label: 'MES' }];
        }
        console.log("grfi",this.lstUsoCupos);
        if(this.lstUsoCupos != undefined && this.lstUsoCupos != null){
          
            let tipoReclamos = this.lstUsoCupos.filter(d=> d.Mes != "6");
     
            this.pieChartLabels = this.lstUsoCupos.map(data=> data.Sugerencia);
            console.log("grfi",   this.pieChartLabels);
            this.pieChartData = this.lstUsoCupos.map(data=> data.MontoSolicitado);
        }

    }


    ngOnChanges(): void {
        
        /*if (this.lstAcepatcionCartera != undefined) {
            this.barChartData = [{ data: [this.lstAcepatcionCartera.MontoSolicitado], label: 'Titulares Asegurados' },
            { data: [this.lstAcepatcionCartera.MontoOtorgado], label: 'Titulares que utilizaron la póliza' }];
        }*/

        if (this.lstSiniestralidad != undefined && this.lstSiniestralidad != null) {


            /*  let mes: Array<any>  = this.lstSiniestralidad.map(data => data.AnioVigencia);
                          this.lineChartLabels = mes;
                          let siniestralidad: Array<any> =new Array<any>();
                          for (let i = 0; i < this.Mensual.length; i++) {
                             siniestralidad.push(Math.floor((Math.random() * 100) + 1));
                          }
                        let reembolso : Array<any> = this.Mensual.map(data=> data.ValorReembolsado);
                         this.lineChartData =[  {data: siniestralidad, label: 'Siniestralidad', yAxisID:"yAxis1"}, {data: reembolso, label: 'Valor Reembolsado Por Mes', yAxisID:"yAxis2"}];
                         let siniestros  : Array<any> = this.Mensual.map(data=> data.NumeroReclamos);
                         this.numReclamosChartData=[{data: siniestralidad, label: 'Siniestralidad', yAxisID:"yAxis1"},  {data: siniestros, label: 'Reclamos por Mes', yAxisID:"yAxis2"}];
                      }*/


            /* if(this.TipoAtencion != undefined){
                 let tipoReclamos = this.TipoAtencion.filter(d=> d.NombreTipo != "TOTAL");
                 this.pieChartLabels = tipoReclamos.map(data=> data.NombreTipo);
                 this.pieChartData = tipoReclamos.map(data=> data.PorcentajeReembolsado);
             }*/
        }

    }

    consultarDetalle() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.detalles.CodigoCiudad = this.consultaCliente.Ciudad;//this.CodigoCiudad;
        this.detalles.CodigoCliente = this.consultaCliente.Cliente;
        this.detalles.CodigoUnidad = 2;
        this.detalles.CodigoGrupo = this.consultaCliente.Grupo;
        this.detalles.CodigoRamo = '2900';
        console.log(this.detalles);
        this.detalles.CodigoTipoNegocio = this.busqueda.CodigoTipoNegocio;
        this.detalles.Opcion = this.opcionCliente;
        //this.cabecera.Poliza=this.detalles;
        this.resumenCredito = new SeguroCreditoEntity();
        this.detalleCredito.consultaDetalleCredito(this.detalles).subscribe(
            result => {
                console.log("detalle", result);
                this.lstAcepatcionCartera = result.AceptacionCartera;
                this.lstSiniestralidad = result.Siniestralidad;
                this.lstUsoCupos = result.UsoCupos;
                this.showLoader = "";
                this.resumenCredito.Mes = result.Mes;
                this.resumenCredito.MontoSolictado = result.MontoSolictado;
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );

        if (this.lstAcepatcionCartera != undefined) {
            console.log("grafico");

            this.barChartData = [{ data: [this.resumenCredito.Mes], label: 'Titulares Asegurados' },
            { data: [this.resumenCredito.MontoSolictado], label: 'Titulares que utilizaron la póliza' }];
        }
    }






    consultarDatosCliente(ConsultaCliente: ConsultaCliente) {

        if (ConsultaCliente != null || ConsultaCliente != undefined) {
            this.showLoader = "sk-loading";
            this.detalleCredito.getDatosCliente(ConsultaCliente).subscribe(data => {
                this.codigounidad = data.Unidad;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar el grupos',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    exportarSiniestralidad() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.detalles.CodigoCiudad = this.CodigoCiudad;
        this.detalles.CodigoCliente = this.busqueda.CodigoCliente;
        this.detalles.CodigoUnidad = this.codigounidad;
        this.detalles.CodigoGrupo = this.codigoGrupo;
        this.detalles.CodigoRamo = this.busqueda.CodigoRamo;
        // this.cabecera.FechaDesde=this.busqueda.FechaDesde;
        // this.cabecera.FechaHasta=this.busqueda.FechaHasta;

        this.detalles.CodigoTipoNegocio = this.busqueda.CodigoTipoNegocio;
        this.detalles.Opcion = this.opcionCliente;
        // console.log(this.cabecera);
        /*this.detalleCredito.exportarSiniestralidadVAMEmpresa(this.cabecera).subscribe(excel => {
            var  a  =  document.createElement("a");
            document.body.appendChild(a);
            a.className  =  "hidden"
            let  fileBlob  = excel.blob();
            let  blob  =  new  Blob([fileBlob], {
                type:  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            let  url  =  window.URL.createObjectURL(blob);
            a.href  =  url;
            a.download  = "DetalleSiniestralidad.xlsx";
            if  (window.navigator  &&  window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob,  "DetalleSiniestralidad.xlsx");
            }
            else  {
                a.click();
                window.URL.revokeObjectURL(url);
            }
            this.showLoader  =  "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al exportar siniestralidad',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            });
            console.log(error)
        })*/
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/seguroCredito/detalleCredito.component.ts